module.exports = function() {
  return new Worker(__webpack_public_path__ + "946845275f39ff4c650e.worker.js");
};